import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiEndpoints } from '../../../api/endpoints';
import Navbar from '../../layout/Navbar';

function TestSuiteCreation() {
  const [formData, setFormData] = useState({
    suite_name: '',
    description: '',
    url: ''
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.suite_name.trim() || !formData.url.trim()) {
      alert('Please provide a test suite name and URL');
      return;
    }

    try {
      await apiEndpoints.createTestSuite(formData);
      navigate('/testsuites');
    } catch (error) {
      if (error.message === 'Unauthorized') {
        localStorage.removeItem('token');
        // navigate('/login');
      }
      console.error('Error creating test suite:', error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md">
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6 text-gray-900">Create Test Suite</h1>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Test Suite Name */}
              <div>
                <label htmlFor="suite_name" className="block text-sm font-medium text-gray-700 mb-2">
                  Test Suite Name
                </label>
                <input
                  type="text"
                  id="suite_name"
                  name="suite_name"
                  value={formData.suite_name}
                  onChange={handleChange}
                  placeholder="Enter test suite name"
                  className="w-full p-2 rounded border border-gray-300 focus:border-black focus:outline-none"
                  required
                />
              </div>

              {/* URL */}
              <div>
                <label htmlFor="url" className="block text-sm font-medium text-gray-700 mb-2">
                  URL
                </label>
                <input
                  type="url"
                  id="url"
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  placeholder="https://example.com"
                  className="w-full p-2 rounded border border-gray-300 focus:border-black focus:outline-none"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Describe the purpose of this test suite..."
                  rows="4"
                  className="w-full p-2 rounded border border-gray-300 focus:border-black focus:outline-none"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-black hover:bg-gray-800 text-white font-bold py-2 px-4 rounded transition-colors"
              >
                Create Test Suite
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestSuiteCreation; 